import React, { useCallback, useMemo } from 'react';
import { FormikProps } from 'formik';
import { Col, Input, Label } from 'reactstrap';

import { useTranslation } from 'react-i18next';
import { EditWorkingTimeFormType } from 'types/timeAttendance/timeAttendanceTypes';
import Flatpickr from 'react-flatpickr';
import { Thai } from 'flatpickr/dist/l10n/th';
import { CalendarFormats } from 'pages/TimeAttendance/constants';

const EditWorkingTimeForm = ({
  formik,
}: {
  formik: FormikProps<EditWorkingTimeFormType>;
}) => {
  const { t, i18n } = useTranslation();
  const getLocale = useCallback(() => {
    switch (i18n.language) {
      case 'th':
        return Thai;

      default:
        return undefined;
    }
  }, [i18n.language]);
  const minSelectableDate = useMemo(() => {
    const today = new Date();
    const minDate = new Date(today);

    minDate.setFullYear(today.getFullYear() - 3);
    minDate.setHours(0, 0, 0, 0);

    return minDate;
  }, []);
  const maxSelectableDate = useMemo(() => {
    const today = new Date();

    today.setHours(23, 59, 59, 999);

    return today;
  }, []);

  return (
    <>
      <div className={`mb-3 row`}>
        <Label htmlFor="#" className="col-sm-4 col-form-label">
          {t('Employee Code')}
        </Label>
        <Col sm={6} className="d-flex align-items-center">
          <div>
            <span>{formik.values.officeCode}</span>
          </div>
        </Col>
      </div>
      <div className={`mb-3 row`}>
        <Label htmlFor="#" className="col-sm-4 col-form-label">
          {t('Full Name')}
        </Label>
        <Col sm={6} className="d-flex align-items-center">
          <div>
            <span>{formik.values.fullName}</span>
          </div>
        </Col>
      </div>
      <div className="mb-3 row">
        <Label htmlFor={`clockInAt`} className="col-sm-4 col-form-label">
          {t('Clock-in Time')} <span className="text-danger">*</span>
        </Label>

        <Col sm={6} xs={12}>
          <Flatpickr
            id="clockInAt"
            name="clockInAt"
            className="form-control"
            options={{
              enableTime: true,
              dateFormat: CalendarFormats.dateTimeFormat,
              time_24hr: true,
              locale: getLocale(),
              minDate: minSelectableDate,
              maxDate: maxSelectableDate,
            }}
            value={formik.values.clockInAt ?? undefined}
            onChange={(date) =>
              formik
                .setFieldValue('clockInAt', date[0])
                .then(() => formik.setFieldTouched('clockInAt', true))
            }
            onClick={() => {
              formik.setFieldTouched('clockInAt', true);
            }}
          />
          <div className="text-danger">{formik.errors.clockInAt}</div>
        </Col>
      </div>
      <div className="mb-3 row">
        <Label htmlFor={`clockOutAt`} className="col-sm-4 col-form-label">
          {t('Clock-out Time')} <span className="text-danger">*</span>
        </Label>

        <Col sm={6} xs={12}>
          <Flatpickr
            id="clockOutAt"
            name="clockOutAt"
            className="form-control"
            options={{
              enableTime: true,
              dateFormat: CalendarFormats.dateTimeFormat,
              time_24hr: true,
              locale: getLocale(),
              minDate: minSelectableDate,
              maxDate: maxSelectableDate,
            }}
            value={formik.values.clockOutAt ?? undefined}
            onChange={(date) =>
              formik
                .setFieldValue('clockOutAt', date[0])
                .then(() => formik.setFieldTouched('clockOutAt', true))
            }
            onClick={() => {
              formik.setFieldTouched('clockOutAt', true);
            }}
          />
          <div className="text-danger">{formik.errors.clockOutAt}</div>
        </Col>
      </div>

      <div className="mb-3 row">
        <Label htmlFor={`note`} className="col-sm-4 col-form-label">
          {t('Note')} <span className="text-danger">*</span>
        </Label>

        <Col sm={6} xs={12}>
          <Input
            type="textarea"
            name="note"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.note}
            maxLength={255}
          />
          <div className="text-danger">{formik.errors.note}</div>
        </Col>
      </div>
      {/* <FormGroup>
        <Label>{t('Employee Code')}</Label>
        <Input disabled value={formik.values.officeCode} />
      </FormGroup>
      <FormGroup>
        <Label>{t('Full Name')}</Label>
        <Input disabled value={formik.values.fullName} />
      </FormGroup>

      <FormGroup>
        <Label>
          {t('Clock-in Time')} <span className="text-danger">*</span>
        </Label>

        <Flatpickr
          id="clockInAt"
          name="clockInAt"
          className="form-control"
          options={{
            enableTime: true,
            dateFormat: 'd M, Y H:i:S',
            time_24hr: true,
            locale: getLocale(),
          }}
          value={formik.values.clockInAt ?? undefined}
          onChange={(date) =>
            formik
              .setFieldValue('clockInAt', date[0])
              .then(() => formik.setFieldTouched('clockInAt', true))
          }
          onClick={() => {
            formik.setFieldTouched('clockInAt', true);
          }}
        />
        <div className="text-danger">{formik.errors.clockInAt}</div>
      </FormGroup>

      <FormGroup>
        <Label>
          {t('Clock-out Time')} <span className="text-danger">*</span>
        </Label>

        <Flatpickr
          id="clockOutAt"
          name="clockOutAt"
          className="form-control"
          options={{
            enableTime: true,
            dateFormat: 'd M, Y H:i:S',
            time_24hr: true,
            locale: getLocale(),
          }}
          value={formik.values.clockOutAt ?? undefined}
          onChange={(date) =>
            formik
              .setFieldValue('clockOutAt', date[0])
              .then(() => formik.setFieldTouched('clockOutAt', true))
          }
          onClick={() => {
            formik.setFieldTouched('clockOutAt', true);
          }}
        />
        <div className="text-danger">{formik.errors.clockOutAt}</div>
      </FormGroup>

      <FormGroup>
        <Label>
          {t('Note')} <span className="text-danger">*</span>
        </Label>
        <Input
          type="textarea"
          name="note"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.note}
          maxLength={255}
        />
        <div className="text-danger">{formik.errors.note}</div>
      </FormGroup> */}
    </>
  );
};

export default EditWorkingTimeForm;
